import Link from "./link"

const PageMenu = ({ links }) => {
  return (
    <div className="section menu--secondary">
      <div className="row">
        <span className="links">
          {links.map((link, index) => {
            return (
              <Link key={index} to={link.url} activeClassName="active" partiallyActive={true}>
                {link.name}
              </Link>
            )
          })}
        </span>
      </div>
    </div>
  )
}

export default PageMenu
